import { render, staticRenderFns } from "./Topup.vue?vue&type=template&id=eb2bece0&scoped=true&"
import script from "./Topup.vue?vue&type=script&lang=js&"
export * from "./Topup.vue?vue&type=script&lang=js&"
import style0 from "./Topup.vue?vue&type=style&index=0&id=eb2bece0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2bece0",
  null
  
)

export default component.exports